export default __webpack_public_path__ + "static/media/img-0342-ukraine-full-face.264773fe.png";